import { createApp } from 'vue';
import 'mosha-vue-toastify/dist/style.css';
import './styles.css';
import '@fortawesome/fontawesome-free/js/all.js';
import { Vue3Lottie } from 'vue3-lottie';


import router from './router.js';
import pinia from './store';
import api from './plugins/api.js';
import utils from './plugins/utils.js';
import App from './App.vue';
import TheHeader from './components/TheHeader.vue';
import VCPresentation from './components/VCPresentation.vue';
import Icon from './components/Icon.vue';
import TheFooter from '@/components/TheFooter.vue';
import QrcodeVue from 'qrcode.vue';

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(api);
app.use(utils);
app.use(Vue3Lottie);
app.component('the-header', TheHeader);
app.component('the-footer', TheFooter);
app.component('vc-presentation', VCPresentation);
app.component('Vue3Lottie', Vue3Lottie);
app.component('icon', Icon);
app.component('qrcode-vue', QrcodeVue);

app.mount('#app');
